import _ from "lodash";
import { constantsActive } from 'utils/constants/constants'
import Translate from 'utils/translate'

const HelperSelect = {
	
	createKeyValue: ( { input, omit_non_active = true , omit_non_active_except_guid = null, omit_non_translatable = true } ) => {
		let output = _.mapValues( input, ( value ) => {
			// inactive AND not selected by guid
			if( omit_non_active && value.active === constantsActive.NO && ( omit_non_active_except_guid === null || value.guid !== omit_non_active_except_guid ) ){
				return undefined;
			}
			
			// non translatable
			if( omit_non_translatable && Translate.field( value, 'title' ) === null ) {
				return undefined;
			}
			
			return {
				value: value.guid,
				label: Translate.field( value, 'title' )
			};
		});
		
		// remove all undefined
		output = _.omitBy( output, _.isUndefined );

		// order
		output = _.orderBy( output, [ 'value' ], [ 'asc' ] );
		
		return Object.values( output );
	}
}

export default HelperSelect
